import {
  QueryGetEmpreendimentosHistoricoResponsaveis,
  QueryGetEmpreendimentosMotivoDescarte,
} from '../../../../../../../graphql'
import {formatDate} from '../../../../common'

type PropsClickInfo = {
  id: number
}

export const HistoricoResponsaveis: React.FC<PropsClickInfo> = ({id}) => {
  console.log(id)

  const {data} = QueryGetEmpreendimentosHistoricoResponsaveis({
    variables: {
      idEmpreendimento: id,
    },
  })
  console.log(data)
  if (!data) {
    return <div>Sem registro</div>
  }
  return (
    <div className='py-5'>
      <table className='table table-striped'>
        <thead className='thead-dark'>
          <tr>
            <th className='text-dark'>Data Cadastro</th>
            <th>Usuário Antigo</th>
            <th>Usuário Novo</th>
            <th>Alterado por</th>
          </tr>
        </thead>
        <tbody>
          {data ? (
            data.GetEmpreendimentosHistoricoResponsaveis.result.map((item) => {
              return (
                <tr>
                  <th>{formatDate(item.data_cadastro)}</th>
                  <th>{item.usuarioAntigo?.name}</th>
                  <th>{item.usuarioNovo?.name}</th>
                  <th>{item.usuarioAlteracao?.name}</th>
                </tr>
              )
            })
          ) : (
            <></>
          )}
        </tbody>
      </table>
    </div>
  )
}
